import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nlTranslation from "./locales/nl/translation.json";

i18n.use(initReactI18next).init({
    resources: {
        nl: { translation: nlTranslation },
    },
    lng: "nl",
    fallbackLng: "nl",
    defaultNS: "translation",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
